export default "__VITE_ASSET__733d7ef1__"